/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Try again.`)
};

const es_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Inténtalo de nuevo.`)
};

const de_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen. Bitte versuche es erneut.`)
};

const nl_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets mis. Probeer het opnieuw.`)
};

const fr_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Réessayez.`)
};

const it_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto. Riprova.`)
};

const pt_br2_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado. Tente novamente.`)
};

const pt_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal. Tenta novamente.`)
};

const ja_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題が発生しました。もう一度お試しください。`)
};

const zh_contact_error_generic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出错了，请重试。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_error_generic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_error_generic(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_error_generic", locale)
	if (locale === "en") return en_contact_error_generic(inputs)
	if (locale === "es") return es_contact_error_generic(inputs)
	if (locale === "de") return de_contact_error_generic(inputs)
	if (locale === "nl") return nl_contact_error_generic(inputs)
	if (locale === "fr") return fr_contact_error_generic(inputs)
	if (locale === "it") return it_contact_error_generic(inputs)
	if (locale === "pt-BR") return pt_br2_contact_error_generic(inputs)
	if (locale === "pt") return pt_contact_error_generic(inputs)
	if (locale === "ja") return ja_contact_error_generic(inputs)
	return zh_contact_error_generic(inputs)
};